import React from 'react';
import * as R from 'ramda';

import { NewProgressField } from 'resources/common';
import { getQuizUnitId } from 'resources/common/quizProgress/quizPathUtils';
import { matchesStudent } from 'resources/common/quizProgress/studentMatch';

const isQuizCompletedByStudent = (student) => (quiz) =>
  Boolean(R.find(matchesStudent(student), R.propOr([], 'submissions', quiz)));

const QuizzesProgressField = ({
  record: student,
  course,
  cohort,
  quizzes: cohortQuizzes = [],
}) => {
  const hiddenUnits = R.pathOr([], [course, 'hidden_units'], cohort);
  const getUnitId = getQuizUnitId;

  const isUnitHidden = (quiz) => {
    const unitId = getUnitId(quiz);
    return R.includes(unitId, hiddenUnits);
  };

  const visibleQuizzes = R.reject(isUnitHidden, cohortQuizzes);

  const isRequired = R.propEq('required', true);
  const requiredQuizzes = R.when(
    R.any(isRequired),
    R.filter(isRequired)
  )(visibleQuizzes);

  const total = R.length(requiredQuizzes);
  const completed = R.pipe(
    R.filter(isQuizCompletedByStudent(student)),
    R.length
  )(requiredQuizzes);
  const text = `${completed}/${total}`;
  const progress = R.defaultTo(0, Math.round((100 * completed) / total));
  return <NewProgressField value={progress} text={text} />;
};

QuizzesProgressField.defaultProps = {
  label: 'Quizzes Progress',
};

export default QuizzesProgressField;
